import React, { AnchorHTMLAttributes, ButtonHTMLAttributes } from 'react';
import { ButtonWrapper, ButtonComponent } from './ButtonV3.styles';

export type ButtonVariant = 'primary' | 'secondary' | 'tertiary' | 'transparent' | 'danger';

export type ButtonV3Props = Partial<ButtonHTMLAttributes<HTMLButtonElement>> &
  Partial<AnchorHTMLAttributes<HTMLAnchorElement>> & {
    component?: ButtonComponent;
    variant?: ButtonVariant;
    bordered?: boolean;
    compact?: boolean;
    fullWidth?: boolean;
    className?: string;
    innerRef?: React.RefObject<any>;
    onClick?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  };

const ButtonV3: React.FC<ButtonV3Props> = ({
  children,
  disabled,
  component: Component = 'button',
  variant = 'primary',
  bordered,
  compact,
  fullWidth,
  className,
  onClick,
  rel,
  role = 'button',
  tabIndex,
  type = 'button',
  href,
  innerRef,
  target,
  ...props
}) => {
  const elementProps = {
    onClick: !disabled && onClick ? onClick : undefined,
    className,
    href: Component === 'a' ? href : undefined,
    tabIndex: Component === 'button' ? tabIndex : undefined,
    variant,
    disabled,
    bordered,
    fullWidth,
    compact,
    type,
    role,
    target,
    rel,
    ...props,
  };

  if (disabled) elementProps.disabled = disabled;
  if (Component === 'button') {
    elementProps.type = type;
    elementProps.role = role;
    if (tabIndex === undefined && disabled) {
      elementProps.tabIndex = -1;
    }
  } else if (Component === 'a') {
    if (target !== '') {
      elementProps.target = target;
      if (target === '_blank') {
        elementProps.rel = `noopener noreferrer ${rel}`;
      }
    }
    if (!href) {
      elementProps.href = '#';
    }
  }

  return (
    <ButtonWrapper as={Component} ref={innerRef} {...elementProps}>
      {children}
    </ButtonWrapper>
  );
};

export default ButtonV3;
